import type { Host } from '@wix/sdk-types';
import { OpenedChannel } from '@wix/communication-channel';
import { ProviderAPI } from '../types';

export const showError =
  (channel: OpenedChannel<ProviderAPI>): Host['showError'] =>
  ({ message, action, requestId }) => {
    if (!message) {
      return;
    }

    channel.showToast({
      type: 'error',
      details:
        requestId != null
          ? {
              requestId,
            }
          : undefined,
      message,
      action: action && {
        ...action,
        removeToastOnClick: true,
        uiType: 'link',
      },
    });
  };
